export const INBOX_TREATMENT_LIST_INFERENCE_EVENTS = 'INBOX_TREATMENT_LIST_INFERENCE_EVENTS';
export const INBOX_TREATMENT_LIST_INFERENCE_EVENTS_SUCCESS = 'INBOX_TREATMENT_LIST_INFERENCE_EVENTS_SUCCESS';
export const INBOX_TREATMENT_LIST_INFERENCE_EVENTS_FAIL = 'INBOX_TREATMENT_LIST_INFERENCE_EVENTS_FAIL';

export const INBOX_TREATMENT_LIST_INFERENCE_EVENTS_CLEAR = 'INBOX_TREATMENT_LIST_INFERENCE_EVENTS_CLEAR';
